export const Permissions = {
  CompanyWrite: 'company:write',
  CandidateRead: 'candidates:read',
  CandidateWrite: 'candidates:write',
  TeamsRead: 'teams:read',
  CandidateChecksSensitiveResults: 'candidate_checks:sensitive_results',
  BrandWrite: 'brand:write',
  FormsWrite: 'forms:write',
  CheckBundlesWrite: 'check_bundles:write',
  BillingWrite: 'billing:write',
  PartnersWrite: 'partners:write',
  CandidateChecksResultsDownload: 'candidate_checks:results:download',
  CandidateChecksResultsRead: 'candidate_checks:results:read',
  CandidateIdsView: 'candidates:ids:read',
  EmailTemplatesWrite: 'email_templates:write',
};

export const PermissionsHuman = {
  'company:write': 'Manage company details',
  'candidates:read': 'View candidates',
  'candidates:write': 'Create candidates',
  'teams:read': 'Access teams',
  'candidate_checks:results:download': 'Download checks results',
  'candidate_checks:results:read': 'View checks results',
  'candidates:ids:read': 'View and download candidate IDs',
  'candidate_checks:sensitive_results': 'View sensitive checks results',
  'brand:write': 'Manage brands',
  'forms:write': 'Manage questionnaires',
  'check_bundles:write': 'Manage check bundles',
  'billing:write': 'Manage billing details',
  'partners:write': 'Manage integrations',
  'renewals:write': 'Manage renewals',
  'email_templates:write': 'Manage email templates',
};
